"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UseAuthServiceErrors = void 0;
var gitlabUrl = 'https://gitlab.alycedev.com/alycecom/frontend-packages/-/blob/dev';
var UseAuthServiceErrors = {
  NotFoundProvider: new Error("[AuthService]: Wrap your app into 'AuthServiceProvider'. Read more - ".concat(gitlabUrl, "/packages/common/src/Auth/hooks/README.md"))
};
exports.UseAuthServiceErrors = UseAuthServiceErrors;